var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.125C7.875 6.29775 7.03425 5.625 6 5.625C5.39025 5.625 4.875 5.2815 4.875 4.875C4.875 4.4685 5.39025 4.125 6 4.125C6.345 4.125 6.6645 4.233 6.876 4.4205C7.03125 4.557 7.2675 4.54425 7.4055 4.389C7.5435 4.23375 7.5285 3.9975 7.374 3.8595C7.11075 3.62625 6.759 3.46875 6.375 3.4065V3C6.375 2.793 6.207 2.625 6 2.625C5.793 2.625 5.625 2.793 5.625 3V3.405C4.77 3.5445 4.125 4.1505 4.125 4.875C4.125 5.70225 4.9665 6.375 6 6.375C6.60975 6.375 7.125 6.7185 7.125 7.125C7.125 7.5315 6.60975 7.875 6 7.875C5.655 7.875 5.3355 7.767 5.124 7.5795C4.96875 7.443 4.73175 7.45575 4.5945 7.611C4.45725 7.76625 4.47075 8.0025 4.626 8.1405C4.88925 8.37375 5.241 8.5305 5.625 8.5935V9C5.625 9.207 5.793 9.375 6 9.375C6.207 9.375 6.375 9.207 6.375 9V8.595C7.23 8.4555 7.875 7.8495 7.875 7.125Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDollar);
export default __webpack_public_path__ + "static/media/avatar_dollar.990f81440384733adae4d1b1411de917.svg";
export { ForwardRef as ReactComponent };